import React from "react"
import {Table, TableBody, TableCell, TableRow, Typography} from "@mui/material"

import {AccountStatusIcon} from "./AccountStatusIcon"
import {AccountMenuTableCell} from "./AccountMenuTableCell"
import {OtherAccountMenu} from "./OtherAccountMenu"
import {AccountDetails} from "./AccountDetails"

import {OtherAccount} from "@indebted/api"

const OtherAccountDetails = ({account, reload}: {account: OtherAccount; reload: () => void}) => (
	<Table size="small">
		<TableBody>
			<TableRow>
				<TableCell>
					<Typography variant="caption" color="textSecondary" display="block">
						Account Ref
					</Typography>
					<Typography variant="body2" display="block">
						<AccountStatusIcon status={account.Status} />
						{account.AccountRef}
					</Typography>
				</TableCell>
				<AccountMenuTableCell>
					<OtherAccountMenu account={account} reload={reload} />
				</AccountMenuTableCell>
			</TableRow>
			<AccountDetails
				details={account.Details}
				itemizationBalanceBreakdown={account.ItemizationBalanceBreakdown}
			/>
		</TableBody>
	</Table>
)

export {OtherAccountDetails}
